import { Optional } from '@/generic/functional';
import type { Organization } from '@/supporting/account/domain/Organization.ts';

type UserToCreate = {
  firstName?: string;
  lastName?: string;
  email: string;
  organization?: Organization;
};

export class User {
  readonly #firstName: Optional<string>;
  readonly #lastName: Optional<string>;
  readonly #email: string;
  readonly #organization: Optional<Organization>;

  private constructor({ firstName, lastName, email, organization }: UserToCreate) {
    this.#firstName = Optional.ofFalsifiable(firstName);
    this.#lastName = Optional.ofFalsifiable(lastName);
    this.#email = email;
    this.#organization = Optional.ofFalsifiable(organization);
  }

  static of(user: UserToCreate): User {
    return new User(user);
  }

  get email(): string {
    return this.#email;
  }

  get organization(): Optional<Organization> {
    return this.#organization;
  }

  get displayName(): string {
    return Optional.ofFalsifiable(this.#names().join(' ')).orElse(this.#email);
  }

  #names(): string[] {
    return [this.#firstName, this.#lastName].flatMap((name) =>
      name.map((value) => [value]).orElse([]),
    );
  }
}
